import { useTranslation } from "react-i18next";
import { getRecency } from "src/helpers/recency";
import "./recencyChip.scss";

/** Small "how long ago" pill for next to an absolute timestamp — same idea as the recency
 *  badges in Zaala/admin (Users/Traffic last-seen columns), ported here with i18n instead
 *  of admin's hardcoded English. */
export function RecencyChip({ timestamp }: { timestamp: number | string | Date }) {
    const { t } = useTranslation();
    const { tone, i18nKey, count } = getRecency(timestamp);
    return (
        <span className={`recency-chip recency-chip--${tone}`}>
            {count !== undefined ? t(i18nKey, { count }) : t(i18nKey)}
        </span>
    );
}
